import { Component, inject, signal } from '@angular/core';
import { LookerEmbedSdkComponent } from "../../../core/ui/looker-embed-sdk/looker-embed-sdk.component";
import { DIALOG_DATA, DialogRef } from "@angular/cdk/dialog";
import { CloseButtonComponent } from "../../../core/ui/close-button/close-button.component";
import { FullscreenToggleDirective } from "../../../core/directives/fullscreen-toggle.directive";
import { ButtonGroupComponent } from "../../../core/shared/ui/button-group/button-group.component";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ThemeService } from "../../../core/services/theme.service";
import { AsyncPipe } from "@angular/common";
import { Router } from "@angular/router";
import { ButtonComponent } from "../../../core/ui/button/button.component";

@Component({
  selector: 'app-ua-optimisation-dashboards',
  imports: [
    LookerEmbedSdkComponent,
    CloseButtonComponent,
    FullscreenToggleDirective,
    ButtonGroupComponent,
    AsyncPipe,
    ButtonComponent,
    TranslateModule
  ],
  templateUrl: './ua-optimisation-dashboards.component.html',
  styleUrl: './ua-optimisation-dashboards.component.scss'
})
export class UaOptimisationDashboardsComponent {

  private translateService = inject(TranslateService);
  private themeService = inject(ThemeService);
  private router = inject(Router);
  theme$ = this.themeService.getCurrentTheme();
  dialogData = inject(DIALOG_DATA)
  dialogRef = inject(DialogRef)
  tabs = signal<{ title: string; active: boolean, dashboard: string, linkTo?: string, linkTitle?: string }[]>([{
    title: this.translateService.instant('global.calendar'),
    active: true,
    dashboard: 'ua_recommendations_detail_calendar',
    linkTo: 'roas-trends',
    linkTitle: this.translateService.instant('titles.reports.ua.open-dashboard', {
      name: this.translateService.instant('titles.product.reports.roas-trends.title')
    })
  }, {
    title: this.translateService.instant('global.cohort'),
    active: false,
    dashboard: 'ua_kpi_tables',
    linkTo: 'kpi-tables',
    linkTitle: this.translateService.instant('titles.reports.ua.open-dashboard', {
      name: this.translateService.instant('titles.product.reports.kpi-tables.title')
    })
  }]);

  get dialogTitle(): string {
    if (!this.dialogData || !this.dialogData.filters) {
      return '';
    }

    const { Country, Platform, Network } = this.dialogData.filters;
    return [Country, Platform, Network].join(" - ")
  }

  onButtonClick($event: string) {
    this.tabs.update(tabs => {
      return tabs.map(tab => ({
        ...tab,
        active: tab.title === $event
      }))
    });
  }

  get activeTab() {
    return this.tabs().find(tab => tab.active);
  }

  openInNewTab() {
    if (!this.dialogData || !this.dialogData.filters) {
      return;
    }

    const activeTab = this.activeTab;
    if (!activeTab) return;

    let targetRoute = activeTab.linkTo;

    const productId = this.dialogData.productId;
    const queryParams = this.dialogData.filters;

    // Navigate to target route in new tab
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/products', productId, 'reports', targetRoute], {
        queryParams
      })
    );

    window.open(url, '_blank');
  }
}
